export default __webpack_public_path__ + "static/media/profilePicture.f75282c1.png";